export const onInitialClientRender = () => {
  const hostname = window.location.hostname
    .replace(/^www\./, "")
    .toLowerCase()

  const tokens = {
    "teatro.feevale.br": "67d8ad24f158ff8b093ac95c14fb6b67",
    "teatrofeevale.com.br": "5bcf25753dd4900e1d4833e2d6b75d71",
  }

  const token = tokens[hostname]

  if (!token || window.__HANDTALK_INITIALIZED__) {
    return
  }

  const initHandTalk = () => {
    if (!window.HT || window.__HANDTALK_INITIALIZED__) {
      return
    }

    try {
      window.__HANDTALK_INITIALIZED__ = true

      window.__HANDTALK_INSTANCE__ = new window.HT({
        token,
        maxTextSize: 1000,
        pageSpeech: true,
      })
    } catch (error) {
      window.__HANDTALK_INITIALIZED__ = false
      console.error("[HandTalk] Erro:", error)
    }
  }

  if (window.HT) {
    initHandTalk()
    return
  }

  const script = document.createElement("script")

  script.id = "handtalk-script"
  script.src =
    "https://plugin.handtalk.me/web/latest/handtalk.min.js"

  script.async = true
  script.onload = initHandTalk

  document.body.appendChild(script)
}